import { Action, createReducer, on } from '@ngrx/store';
import { buySubscription, buySubscriptionFailure, buySubscriptionSuccess, fetchSubscriptionPlans, fetchSubscriptionPlansFailure, fetchSubscriptionPlansSuccess, fetchSubscriptionVendorPlan, fetchSubscriptionVendorPlanFailure, fetchSubscriptionVendorPlanSuccess } from './subscription.actions';
import { SubscriptionModel } from '../../core/models/subscription.models';

export interface SubscriptionState {
    loading: boolean;
    error: any;
    isSubscriptionSuccess: boolean;
    subsriptionPlans: any;
    vendorSubscriptionPlan: SubscriptionModel | null
}

export const initialState: SubscriptionState = {
    loading: false,
    error: null,
    isSubscriptionSuccess: false,
    subsriptionPlans: null,
    vendorSubscriptionPlan: null
};

export const subscriptionReducer = createReducer(
    initialState,

    // Subscription
    on(buySubscription, (state) => {
        return { ...state, loading: true, error: null, isSubscriptionSuccess: false };
    }),
    on(buySubscriptionSuccess, (state) => {
        return { ...state, loading: false, isSubscriptionSuccess: true };
    }),
    on(buySubscriptionFailure, (state, { error }) => {
        return { ...state, error, loading: false, isSubscriptionSuccess: false };
    }),

    //Get Subscription
    on(fetchSubscriptionPlans, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchSubscriptionPlansSuccess, (state, { subsriptionPlans }) => {
        return { ...state, loading: false, subsriptionPlans };
    }),
    on(fetchSubscriptionPlansFailure, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    //Get Subscription
    on(fetchSubscriptionVendorPlan, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchSubscriptionVendorPlanSuccess, (state, { subsriptionPlans }) => {
        return { ...state, loading: false, vendorSubscriptionPlan: subsriptionPlans };
    }),
    on(fetchSubscriptionVendorPlanFailure, (state, { error }) => {
        return { ...state, error, loading: false };
    })
);

// Selector
export function reducer(state: SubscriptionState | undefined, action: Action) {
    return subscriptionReducer(state, action);
}
